export default "__VITE_ASSET__m$4$2Ed9__"